import { v1 as uuid } from "uuid";
import NavNode from "@/services/NavigationNode";

const uid = function (items: NavNode[]) {
	items.forEach((i) => {
		i.uid = uuid();
		uid(i.nodes);
	});
};

export default uid;
